// extracted by mini-css-extract-plugin
module.exports = {"products":"provider-products-tab_products_1tsg4"};